/*=========================================================================================
  File Name: moduleCategoryMutations.js
  Description: Category Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
const formatObj = function (newField) {
	const obj = {};
	const validateRequired = (required) => (required ? ["string"] : ["string", "null"]); // no required ["string","null"], required = ["string"]
	const validateRequiredNum = (required) => (required ? ["number"] : ["number", "null"]); // no required ["number","null"], required = ["number"]
	switch (newField.type) {
		case "select":
			obj.type = validateRequired(newField.required);
			obj.enum = newField.required
				? newField.options.map(({value}) => value)
				: ["", null].concat(newField.options.map(({value}) => value));
			break;
		case "text":
		case "location":
			obj.type = validateRequired(newField.required);
			obj.minLength = newField.required ? 1 : 0;
			break;
		case "number":
			obj.type = validateRequiredNum(newField.required);
			break;
		case "email":
			obj.type = validateRequired(newField.required);
			obj.pattern =
				"^([a-z0-9-+*=&'/?^_}{~|`]+)(.?[a-z0-9-+*=&'/?^_}{~|`]+)*@[a-z0-9]+((-|.)[a-z0-9]+)*(.[a-z0-9]{1,20})$";
			break;
		case "url":
		case "file":
		case "img":
			obj.type = validateRequired(newField.required);
			obj.format = "uri";
			break;
		case "date":
			obj.type = validateRequired(newField.required);
			obj.format = "date";
			break;
		case "check":
			obj.items = {
				enum: newField.options.map((value) => value),
				type: validateRequired(newField.required),
			};
			obj.type = "array";
			break;
		case "location_default":
			obj.pattern =
				"^(\\+|-)?(0.0|(0|[1-8]?[0-9]).\\d{5,}|90.\\d[0]{4,}),(\\+|-)?(0.0|(0|[1-9][0-9]?|1[0-7][0-9]).\\d{5,}|180.\\d[0]{4,})$";
			obj.type = validateRequired(newField.required);
			break;
		default:
			break;
	}
	return obj;
};
export default {
	ADD_CATEGORY(state, category) {
		state.categories.unshift(category);
	},
	SET_CATEGORIES(state, categories) {
		state.categories = categories;
	},
	SET_DESCRIPTION(state, data) {
		state.categories[data.index].description = data.new_escription;
	},
	UPDATE_CATEGORY(state, category) {
		const categoryIndex = state.categories.findIndex((p) => p.id === category.id);
		if (categoryIndex !== -1) {
			Object.assign(state.categories[categoryIndex], category);
		}
	},
	REMOVE_CATEGORY(state, itemId) {
		const ItemIndex = state.categories.findIndex((t) => t.id === itemId);
		state.categories.splice(ItemIndex, 1);
	},
	ADD_NEW_FIELD(state, newField) {
		const obj = formatObj(newField);
		const categoryIndex = state.categories.findIndex((p) => p.id === newField.id);
		if (newField.required) {
			state.categories[categoryIndex].json_base.properties.additional_info.required.push(newField.name);
		}
		state.categories[categoryIndex].json_base.properties.additional_info.properties[newField.name] = obj;
		state.categories[categoryIndex].json_properties.push(newField);
	},
	REMOVE_FIELD(state, field) {
		const categoryIndex = state.categories.findIndex((p) => p.id === field.id);
		const i = state.categories[categoryIndex].json_base.properties.additional_info.required.findIndex(
			(e) => e === field.name
		);
		state.categories[categoryIndex].json_base.properties.additional_info.required.splice(i, 1);
		delete state.categories[categoryIndex].json_base.properties.additional_info.properties[field.name];
		const j = state.categories[categoryIndex].json_properties.findIndex((e) => e.name === field.name);
		state.categories[categoryIndex].json_properties.splice(j, 1);
	},
};
